import React from "react";
import { Card, Col, Descriptions, Form, Input, Row } from "antd";
import { useTranslation } from "react-i18next";

const ContactField = ({ mode, companyCode }) => {
  const { t } = useTranslation();
  const form = Form.useFormInstance();
  const isViewMode = mode === "VIEW";

  if (isViewMode) {
    const contact = form.getFieldValue(["companies", companyCode, "contact"]) || {};

    return (
      <Row gutter={16}>
        <Col span={24}>
          <Card>
            <Descriptions column={{ xs: 1, sm: 2, md: 2 }} bordered size="small">
              <Descriptions.Item label={t("countries.email")}>{contact.email || "-"}</Descriptions.Item>
              <Descriptions.Item label={t("countries.email_support")}>{contact.emailSupport || "-"}</Descriptions.Item>
              <Descriptions.Item label={t("countries.email_link")}>{contact.emailLink || "-"}</Descriptions.Item>
              <Descriptions.Item label={t("countries.website_url")}>{contact.url || "-"}</Descriptions.Item>
              <Descriptions.Item label={t("countries.phone")}>{contact.phone || "-"}</Descriptions.Item>
              <Descriptions.Item label={t("countries.phone_link")}>{contact.phoneLink || "-"}</Descriptions.Item>
              <Descriptions.Item label={t("countries.whatsapp_link")}>{contact.whatsappLink || "-"}</Descriptions.Item>
              <Descriptions.Item label={t("countries.google_maps_link")}>
                {contact.googleMapsLink || "-"}
              </Descriptions.Item>
              <Descriptions.Item label={t("countries.privacy_policy_link")}>
                {contact.privacyPolicyLink || "-"}
              </Descriptions.Item>
              <Descriptions.Item label={t("countries.terms_link")}>{contact.termsLink || "-"}</Descriptions.Item>
              <Descriptions.Item label={t("countries.copyright")} span={2}>
                {contact.copyright || "-"}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
      </Row>
    );
  }

  return (
    <Row gutter={16}>
      <Col span={24}>
        <Card>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item name={["companies", companyCode, "contact", "email"]} label={t("countries.email")}>
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name={["companies", companyCode, "contact", "emailSupport"]}
                label={t("countries.email_support")}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item name={["companies", companyCode, "contact", "emailLink"]} label={t("countries.email_link")}>
                <Input placeholder="mailto:info@example.com" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item name={["companies", companyCode, "contact", "url"]} label={t("countries.website_url")}>
                <Input placeholder="https://www.example.com/" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item name={["companies", companyCode, "contact", "phone"]} label={t("countries.phone")}>
                <Input placeholder="+31616092321" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item name={["companies", companyCode, "contact", "phoneLink"]} label={t("countries.phone_link")}>
                <Input placeholder="tel:+31616092321" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name={["companies", companyCode, "contact", "whatsappLink"]}
                label={t("countries.whatsapp_link")}
              >
                <Input placeholder="https://wa.me/+31616092321" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name={["companies", companyCode, "contact", "googleMapsLink"]}
                label={t("countries.google_maps_link")}
              >
                <Input placeholder="https://maps.app.goo.gl/..." />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name={["companies", companyCode, "contact", "privacyPolicyLink"]}
                label={t("countries.privacy_policy_link")}
              >
                <Input placeholder="https://www.example.com/privacy-policy/" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item name={["companies", companyCode, "contact", "termsLink"]} label={t("countries.terms_link")}>
                <Input placeholder="https://www.example.com/terms/" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item name={["companies", companyCode, "contact", "copyright"]} label={t("countries.copyright")}>
                <Input placeholder="Copyright © 2024 Chef's Farm B.V." />
              </Form.Item>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default ContactField;
